/**
 * Critical JavaScript for Top Page
 * トップページに必要最小限の機能のみを含む軽量版JS
 * 
 * 含まれる機能:
 * - 基本的なヘルパー関数
 * - ナビゲーション
 * - スライダー機能（トップページ用）
 * - 画像の遅延読み込み処理
 */

// 基本的なヘルパー関数
window.theme = window.theme || {};

theme.Helpers = (function() {
  'use strict';
  
  var touchDevice = false;
  var scrollPosition = window.pageYOffset;
  
  var classes = {
    preventScrolling: 'prevent-scrolling'
  };

  function setTouch() {
    touchDevice = true;
  }

  function isTouch() {
    return touchDevice;
  }

  function debounce(func, wait, immediate) {
    var timeout;
    return function() {
      var context = this;
      var args = arguments;
      var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  function enableScrollLock() {
    scrollPosition = window.pageYOffset;
    document.body.style.top = '-' + scrollPosition + 'px';
    document.body.classList.add(classes.preventScrolling);
  }

  function disableScrollLock() {
    document.body.classList.remove(classes.preventScrolling);
    document.body.style.removeProperty('top');
    window.scrollTo(0, scrollPosition);
  }

  return {
    setTouch: setTouch,
    isTouch: isTouch,
    debounce: debounce,
    enableScrollLock: enableScrollLock,
    disableScrollLock: disableScrollLock
  };
})();

// 軽量スライダー機能（トップページのメインバナー用）
theme.SimpleSlider = (function() {
  'use strict';

  function SimpleSlider(container, options) {
    this.container = container;
    this.slider = container.querySelector('[data-slider]');
    
    if (!this.slider) return;
    
    this.options = Object.assign({}, {
      autoplay: true,
      slideInterval: 3000,
      slidesToShow: 1,
      fadeEffect: true
    }, options);
    
    this.slides = Array.from(this.slider.querySelectorAll('[data-slider-item]'));
    this.currentSlide = 0;
    this.isAutoPlaying = false;
    
    if (this.slides.length <= 1) return;
    
    this.init();
  }

  SimpleSlider.prototype = {
    init: function() {
      this.setupSlides();
      if (this.options.autoplay) {
        this.startAutoplay();
      }
      this.bindEvents();
    },
    
    setupSlides: function() {
      this.slides.forEach(function(slide, index) {
        slide.style.opacity = index === 0 ? '1' : '0';
        slide.style.transition = 'opacity 0.5s ease-in-out';
        slide.style.position = index === 0 ? 'relative' : 'absolute';
        slide.style.top = '0';
        slide.style.left = '0';
        slide.style.width = '100%';
      });
    },
    
    goToSlide: function(index) {
      var previousSlide = this.currentSlide;
      this.currentSlide = index;
      
      this.slides[previousSlide].style.opacity = '0';
      this.slides[previousSlide].style.position = 'absolute';
      
      this.slides[this.currentSlide].style.opacity = '1';
      this.slides[this.currentSlide].style.position = 'relative';
    },
    
    nextSlide: function() {
      var nextIndex = (this.currentSlide + 1) % this.slides.length;
      this.goToSlide(nextIndex);
    },
    
    startAutoplay: function() {
      var self = this;
      this.isAutoPlaying = true;
      this.autoplayTimer = setInterval(function() {
        self.nextSlide();
      }, this.options.slideInterval);
    },
    
    stopAutoplay: function() {
      this.isAutoPlaying = false;
      clearInterval(this.autoplayTimer);
    },
    
    bindEvents: function() {
      var self = this;
      
      // タッチ開始時にオートプレイを停止
      this.container.addEventListener('touchstart', function() {
        self.stopAutoplay();
      });
      
      // マウスオーバー時にオートプレイを停止
      this.container.addEventListener('mouseenter', function() {
        self.stopAutoplay();
      });
      
      // マウスリーブ時にオートプレイを再開
      this.container.addEventListener('mouseleave', function() {
        if (self.options.autoplay) {
          self.startAutoplay();
        }
      });
    },
    
    destroy: function() {
      this.stopAutoplay();
    }
  };

  return SimpleSlider;
})();

// モバイルナビゲーション（簡略版）
theme.MobileNavLight = (function() {
  'use strict';

  var classes = {
    mobileNavOpenIcon: 'mobile-nav--open',
    mobileNavCloseIcon: 'mobile-nav--close',
    navOpen: 'js-menu--is-open'
  };

  function init() {
    var mobileNavToggle = document.querySelector('.js-mobile-nav-toggle');
    var mobileNavContainer = document.querySelector('.mobile-nav-wrapper');
    
    if (!mobileNavToggle || !mobileNavContainer) return;
    
    mobileNavToggle.addEventListener('click', function() {
      var isOpen = mobileNavContainer.classList.contains(classes.navOpen);
      
      if (isOpen) {
        closeMobileNav();
      } else {
        openMobileNav();
      }
    });
  }

  function openMobileNav() {
    var mobileNavToggle = document.querySelector('.js-mobile-nav-toggle');
    var mobileNavContainer = document.querySelector('.mobile-nav-wrapper');
    
    mobileNavContainer.classList.add(classes.navOpen);
    mobileNavToggle.classList.add(classes.mobileNavCloseIcon);
    mobileNavToggle.classList.remove(classes.mobileNavOpenIcon);
    
    theme.Helpers.enableScrollLock();
  }

  function closeMobileNav() {
    var mobileNavToggle = document.querySelector('.js-mobile-nav-toggle');
    var mobileNavContainer = document.querySelector('.mobile-nav-wrapper');
    
    mobileNavContainer.classList.remove(classes.navOpen);
    mobileNavToggle.classList.add(classes.mobileNavOpenIcon);
    mobileNavToggle.classList.remove(classes.mobileNavCloseIcon);
    
    theme.Helpers.disableScrollLock();
  }

  return {
    init: init,
    close: closeMobileNav
  };
})();

// 画像の遅延読み込み処理
theme.LazyLoadHandler = (function() {
  'use strict';

  function removeImageLoadingAnimation(image) {
    var imageWrapper = image.hasAttribute('data-image-loading-animation')
      ? image
      : image.closest('[data-image-loading-animation]');

    if (imageWrapper) {
      imageWrapper.removeAttribute('data-image-loading-animation');
    }
  }

  function init() {
    document.querySelectorAll('img').forEach(function(image) {
      if (image.complete) {
        removeImageLoadingAnimation(image);
        return;
      }

      image.addEventListener('load', function() {
        removeImageLoadingAnimation(image);
      }, { once: true });
    });
  }

  return {
    init: init
  };
})();

// トップページ初期化
document.addEventListener('DOMContentLoaded', function() {
  'use strict';
  
  // タッチデバイス検出
  document.addEventListener('touchstart', function() {
    theme.Helpers.setTouch();
  }, { once: true });

  // モバイルナビゲーション初期化
  theme.MobileNavLight.init();

  // 画像遅延読み込み初期化
  theme.LazyLoadHandler.init();

  // メインスライダー初期化（トップページのバナー）
  var mainSlider = document.querySelector('[data-main-slider]');
  if (mainSlider) {
    new theme.SimpleSlider(mainSlider, {
      autoplay: true,
      slideInterval: 3000
    });
  }

  // パフォーマンス計測
  if (window.performance && window.performance.mark) {
    window.performance.mark('critical-js-loaded');
  }
});

// 遅延読み込み用のスクリプト読み込み関数
theme.LoadDeferred = function() {
  'use strict';
  
  if (window.deferredLoaded) return;
  window.deferredLoaded = true;

  // deferred-features.jsを動的に読み込み
  var script = document.createElement('script');
  script.src = window.theme.assets.deferredFeaturesUrl || '/assets/deferred-features.js';
  script.async = true;
  script.onload = function() {
    if (window.performance && window.performance.mark) {
      window.performance.mark('deferred-js-loaded');
    }
  };
  document.head.appendChild(script);
};

// ユーザーインタラクション後に遅延読み込み
var userInteracted = false;
var interactionEvents = ['click', 'keydown', 'scroll', 'touchstart'];

function loadDeferredOnce() {
  if (!userInteracted) {
    userInteracted = true;
    
    // イベントリスナーを削除
    interactionEvents.forEach(function(event) {
      document.removeEventListener(event, loadDeferredOnce, { passive: true });
    });
    
    // 少し遅延してから読み込み
    setTimeout(theme.LoadDeferred, 100);
  }
}

// ユーザーインタラクションを待機
interactionEvents.forEach(function(event) {
  document.addEventListener(event, loadDeferredOnce, { passive: true });
});

// フォールバック: 3秒後に自動読み込み
setTimeout(function() {
  if (!userInteracted) {
    theme.LoadDeferred();
  }
}, 3000);

console.log('Critical JS loaded - Top page optimized');
